import { useState } from 'react';
import LoginGate from './LoginGate';
import SignUpForm from './SignUpForm';

type Mode = 'login' | 'signup';

export default function AuthLanding(): JSX.Element {
  const [mode, setMode] = useState<Mode>('signup');

  if (mode === 'signup') {
    return <SignUpForm onSwitchToLogin={() => setMode('login')} />;
  }
  return <LoginGate onSwitchToSignUp={() => setMode('signup')} />;
}
